import axios from 'axios';

export const categoriaGastoApi = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND!}api`,
  headers: { "Content-Type": "application/json" },
});
